$ = require("jquery");
$(function() {
  var appear = false;
  var fixedbtn = $('.floatingbnr');
  $(window).scroll(function () {
    if ($(this).scrollTop() > 800 && $(this).scrollTop() < 100000) {
      if (appear == false) {
        appear = true;
        fixedbtn.stop().animate({
          'bottom': '15px'
        }, 300);
        $('.fixedbtn').css('display','block');
      }
    } else {
      if (appear) {
        appear = false;
        fixedbtn.stop().animate({
          'bottom': '-150px' //
        }, 300);
      }
    }
  });
});
